import React, { useContext, useMemo } from "react";
import { AnnualTradingReportData } from "../../../data/reports/annualTrade/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Action } from "material-table";
import { useHistory } from "react-router-dom";
//import { useViewBank } from "./DisplayBank";
import {
  getProductLocation,
  getClientLocation,
  getDateLocation,
} from "./Locations";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import PeopleOutlineOutlinedIcon from "@material-ui/icons/PeopleOutlineOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import { useAuth } from "../../../data/auth/hooks";

export const useAnnualActions = () => {
  const { getString } = useContext(LocalizationContext);

  const history = useHistory();

  const [auth] = useAuth();

  return useMemo(() => {
    const result: Action<AnnualTradingReportData>[] = [
      {
        icon: () => <LocalShippingOutlinedIcon />,
        tooltip: getString("aTableProduct"),
        onClick: (event, rowData) => {
          const reportData = rowData as AnnualTradingReportData;
          history.push(getProductLocation(reportData.year));
        },
      },
      {
        icon: () => <PeopleOutlineOutlinedIcon />,
        tooltip: getString("aTableClient"),
        onClick: (event, rowData) => {
          const reportData = rowData as AnnualTradingReportData;
          history.push(getClientLocation(reportData.year));
        },
        hidden:  auth.status === "successful" && (auth.user.roleCode === "MEMTRADER" || auth.user.roleCode === "MEMMANAGER"  ||  auth.user.roleCode === "MEMCONTACT" )  
      },
      {
        icon: () => <EventOutlinedIcon />,
        tooltip: getString("aTableDate"),
        onClick: (event, rowData) => {
          const reportData = rowData as AnnualTradingReportData;
          history.push(getDateLocation(reportData.year));
        },
      },
    ];

    return result;
  }, [, , getString]);
};
